//import * as _ from "lodash";  // awh todo - remove this dependency
import { Point } from './Point'
import { Rectangle } from './Rectangle'
import { Id_finding, Id_category, Id_floor, Id_workorder, Id_location } from './api/Identifiers'
import { Category, CategoryCollection } from './Categories'
import { Translate, Distance, Nudge } from './Geometry'
import { Configuration } from "./Configuration";
import { exists } from './utils'
import { QueryString } from './QueryString'

let filter_id_category: Id_category = Configuration.filter_finding_id_category;
let is_filtering_on = (filter_id_category !== null);

interface FindingJSON {
    adj_coords: number[];
    adjP1P2: any[];
    category: number;
    coords: number[];
    findingNumber: number;
    has_findingNumber: boolean;
    has_coords: boolean;
    icon: string;
    id_finding: string;   // id_finding is a UUID
    id_floor: number;
    id_location: number;
    location_label: string;
    rawCoords: number[];
    rawP1P2: number[];
}

export class Finding {
    private _adj_coord: Point;
    private _adj_geoRef: Rectangle;
    private _finding_number: number;
    private _has_findnig_number: boolean = false;
    private _has_coords: boolean = true;
    private _icon: string;
    private _id_category: Id_category = null;
    private _id_floor: Id_floor;
    private _id_location: Id_location;
    private _id: Id_finding;
    private _location_label: string;
    private _raw_coord: Point;
    private _raw_geoRef: Rectangle;
    private _raw: any;

    get id_floor(): Id_floor {
        if (!this._id_floor) {
            return this._id_location;
        }
        return this._id_floor;
    }

    public get icon(): string {
        return this._icon;
    }
    public get id(): Id_finding {
        return this._id;
    }

    public get findingNumber(): number {
        return this._finding_number;
    }

    public get has_findingNumber(): boolean{
        return this._has_findnig_number;
    }

    public get category(): Id_category {
        return this._id_category;
    }

    public get coord(): Point {
        let ret_val: Point = this._adj_coord;
        if (!ret_val) {
            ret_val = this._raw_coord;
        }
        return ret_val;
    }

    public get location_label(): string {
        return this._location_label
    }

    public get adj_coord(): Point {
        let ret_val: Point = this._adj_coord;
        if (!ret_val) {
            ret_val = this.raw_coord;
            if (!ret_val) {
                ret_val = Point.NULL;
            }
        }
        return ret_val;
    }

    private get adj_geoRef(): Rectangle {
        let ret_val: Rectangle = this._adj_geoRef;
        if (!ret_val) {
            ret_val = this._raw_geoRef;
            if (!ret_val) {
                ret_val = Rectangle.NULL;
            }
        }
        return ret_val;
    }

    public get raw_coord(): Point {
        if (!this._has_coords) {
            // pass
            return Point.build(5000, 5000);
        }

        return this._raw_coord;

    }


    public get raw_geoRef(): Rectangle {
        let ret_val: Rectangle = this._raw_geoRef;
        if (!ret_val) {
            ret_val = Rectangle.NULL;
        }
        return ret_val;
    }

    public get id_category(): Id_category {
        return this._id_category;

    }

    public is_valid(): boolean {
        if (this._raw_coord.X) {
            if (this._raw_coord.Y) {
                if (this._icon) {
                    if (this._icon !== "") {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    public translate_finding(drawing_p1p2: Rectangle, p0: Point): void {
        if (drawing_p1p2) {
            if (!this._has_coords) {
                // if this finding has no coords, set the adj coord to the provided p0
                this._adj_coord = p0;
                this._adj_geoRef = drawing_p1p2;

            } else {
                this._adj_coord = Translate(this.raw_coord, this._raw_geoRef, drawing_p1p2);
                this._adj_geoRef = drawing_p1p2;
            }
        }
    }

    public get raw(): any {
        return this._raw;
    }

    public static build_from_raw(raw_finding: any): Finding {

        let r: Finding = new Finding
        r._location_label = ""
        if (raw_finding.finding) {
            // sometimes the raw finding is buried under an finding field
            raw_finding = raw_finding.finding
        }
        r._raw = Object.assign({}, raw_finding);

        r._id = Id_finding.wrap(raw_finding.id)
        if (!r._id) {
            r._id = Id_finding.wrap(raw_finding.idRoundFinding)
        }
        if (!r._id) {
            console.debug(`finding is missing an id field`)
            return null;
        }
        if (!raw_finding.findingNumber) {
            console.debug('finding is missing FindingNumber field')
            r._finding_number = null;
            r._has_findnig_number = false;
        }
        else{
            r._finding_number = raw_finding.findingNumber;
            r._has_findnig_number = true;
        }

        r._id_category = Id_category.wrap(raw_finding.idCategory);
        if (!r._id_category) {
            console.debug("Finding" + r._id.toString() + " is missing required idCategory field.")
            return null;
        }
        if (exists(raw_finding.location)) {
            r._location_label = raw_finding.location
        }

        if (exists(raw_finding.locationOther)) {
            r._location_label = `${r._location_label} - ${raw_finding.locationOther}`
        }
        r._id_location = Id_location.wrap(raw_finding.idLocation);
        r._id_floor = Id_floor.wrap(raw_finding.idFloor);
        r._raw_coord = Point.build(raw_finding.xCoord, raw_finding.yCoord);
        if (!r._raw_coord) {
            r._raw_coord = Point.build(5000, 5000);
            r._has_coords = false;
        }
        else {
            if (r._raw_coord.X === 0 && r._raw_coord.Y === 0) {
                r._has_coords = false;
            }
            if (r._raw_coord.X === 500 && r._raw_coord.Y === 500) {
                r._has_coords = false;
            }
            if (r._raw_coord.X === 5000 && r._raw_coord.Y === 5000) {
                r._has_coords = false;
            }
        }
        r._icon = utilsFindingIcon(raw_finding.icon);

        r._raw_geoRef = Rectangle.build_from_numbers(raw_finding.p1XCoord,
            raw_finding.p1YCoord,
            raw_finding.p2XCoord,
            raw_finding.p2YCoord)
        if (!r._raw_geoRef) {
            // awh todo: reject this finding. don't store it
            r._raw_geoRef = Rectangle.NULL;
        }
        return r;
    }

    public get has_coords(): boolean { return this._has_coords; }

    public toJSON(): FindingJSON {
        const r: FindingJSON = {
            adj_coords: this.adj_coord.toJSON(),
            adjP1P2: this.adj_geoRef.toJSON(),
            category: this._id_category.value,
            coords: this.adj_coord.toJSON(),
            findingNumber: this._finding_number,
            has_findingNumber: this._has_findnig_number,
            has_coords: this.has_coords,
            icon: this._icon,
            id_finding: this._id.value,
            id_floor: this.id_floor.value,
            id_location: this.id_floor.value,  // AWH - reconcile this
            location_label: this._location_label,
            rawCoords: this.raw_coord.toJSON(),
            rawP1P2: this._raw_geoRef.toJSON(),
        };
        return r
    }

    public nudge(rhs: Finding): void {
        if (this.category === rhs.category) {
            // only nudge if the findings are the same category
            if (this.id_floor.equals(rhs.id_floor)) {
                // only nudge if the findings are on the same floor

                if (!this.id.equals(rhs.id)) {
                    // only nudge if the ids don't match
                    if (this._adj_coord) {
                        if (rhs._adj_coord) {
                            Nudge(this._adj_coord, rhs._adj_coord, 45, 20);
                        }
                    }
                }
            }
        }
    }
}



export class FindingCollection {

    private _findings: any = {};  // {id_finding:Finding}
    private _findings_sorted_by_floor: any = {};   //{(key:string):Id_finding[]} = null;
    private __findings_list: Finding[] = null;  // {id_finding:Finding}
    private __json: any = null;
    private __categories: Set<Id_category> = new Set<Id_category>()
    //private __findings_sorted_by_floor_json: any = null;

    public get categories(): Id_category[] {
        return Array.from(this.__categories);
    }
    public static empty(): FindingCollection { return new FindingCollection(); };


    public constructor() {

    }

    public get count(): number {
        return this.findings.length;
    }
    public get findings(): Finding[] {

        if (!this.__findings_list) {
            this.__findings_list = []
            Object.keys(this._findings).forEach((id_finding: string) => {
                this.__findings_list.push(this._findings[id_finding]);
            })
        }
        return this.__findings_list;
    }

    public get_finding(id_finding: Id_finding): Finding {
        let r: Finding = this._findings[id_finding.value];
        if (!r) {
            return null;
        }
        return r;
    }


    public get_findings_on_floor(id_floor: Id_floor): FindingCollection {
        let r: FindingCollection = new FindingCollection();
        this.findings.forEach((finding: Finding) => {
            if (finding.id_floor.equals(id_floor)) {
                r.add_finding(finding)
            }
        })
        return r;
    }

    public get_findings_by_category_json(id_category: Id_category): any {
        let r: any = {}

        this.findings.forEach((finding: Finding) => {
            let id_category: string = finding.id_category.toString();
            if (!r[id_category]) {
                r[id_category] = []
            }
            r[id_category].push(finding.toJSON());
        })
        return r;
    }


    public get length(): number {
        return Object.keys(this._findings).length;
    }

    public static build_from_raw(raw_findings: any[]): Finding[] {
        let r: Finding[] = [];
        raw_findings.forEach((raw_finding: any) => {
            let new_finding: Finding = Finding.build_from_raw(raw_finding)

            if (new_finding) {
                r.push(new_finding);
            }
            else {
                console.debug(`null finding created by ${raw_finding}`)
            }
        })
        if (is_filtering_on) {
            r = r.filter((finding: Finding) => {
                return finding.id_category.equals(filter_id_category);
            })
        }


        return r;
    }



    public static wrap(findings: Finding[]): FindingCollection {
        let r: FindingCollection = new FindingCollection();
        findings.forEach((finding: any) => {
            r.add_finding(finding);
        })
        return r;
    }

    public add_findings(findings: Finding[]) {
        findings.forEach((finding: Finding) => this.add_finding(finding));
    }

    private add_finding(finding: Finding) {

        this._findings[finding.id.value] = finding;
        let floor_key = finding.id_floor.toString();

        // add the finding to the floor-sorted table
        if (!this._findings_sorted_by_floor[floor_key]) {
            this._findings_sorted_by_floor[floor_key] = [];
        }
        this._findings_sorted_by_floor[finding.id_floor.toString()].push(finding.id);

        this.__json = null;
        this.__findings_list = null;
        this.__categories.add(finding.category);
    }

    public get_findings_by_category(category: Category): Finding[] {
        return this.findings.filter((finding: Finding) => finding.id_category.equals(category.id_category));
    }

    public get_findings_by_category_id(id_category: string): Finding[] {
        return this.findings.filter((finding: Finding) => { return finding.id_category.toString() === id_category; });
    }

    public get_categories(): string[] {
        let mySet = new Set<string>();
        this.findings.forEach((finding: Finding) => mySet.add(finding.id_category.toString()));
        return Array.from(mySet);
    }

    public toJSON(): any {
        if (this.__json === null) {
            this.__json = JSON.parse(JSON.stringify(Object.keys(this._findings)));
        }
        return this.__json;
    }

    // assume the finding contains adj_coords
    private declusterFindings(id_location: Id_location) {
        let declusterCore = () => {
            this.findings.forEach((lhs: Finding) => {

                if (!lhs.id_floor.equals(id_location)) {
                    return
                }

                if (!lhs.has_coords) {
                    return;
                }
                this.findings.forEach((rhs: Finding) => {
                    if (!rhs.has_coords) {
                        return;
                    }
                    if (lhs.category == rhs.category) {
                        // only perform decluster of findings that are the same category
                        if (lhs.id.equals(rhs.id)) {
                            // lhs and rhs are the same. ignore
                        }
                        else {
                            lhs.nudge(rhs)
                        }
                    }
                })
            })
        }

        // run the decluster algorithm multiple times
        declusterCore();
        declusterCore();
    }

    public translate_findings(drawing_p1p2: Rectangle, id_location: Id_location, p0: Point, nudge_overlapping: boolean) {
        this.findings.forEach((finding: Finding) => {
            if (finding.id_floor.equals(id_location)) {
                finding.translate_finding(drawing_p1p2, p0);
                //       this.__findings_sorted_by_floor_json = null;
            }
        });
        if (nudge_overlapping) {
            this.declusterFindings(id_location);
        }

    }

    // returns a JSON object of all findings indexed by floor
    public sorted_by_floor_json(): any {
        let __findings_sorted_by_floor_json: any = {}
        this.findings.forEach((finding: Finding) => {
            let id_location: string = finding.id_floor.toString();
            if (!__findings_sorted_by_floor_json[id_location]) {
                __findings_sorted_by_floor_json[id_location] = []
            }
            __findings_sorted_by_floor_json[id_location].push(finding.toJSON());
        })
        return __findings_sorted_by_floor_json;
    }
}

function utilsFindingIcon(cms_view_icon: string): string {
    if (!cms_view_icon) {
        return "";
    }
    let icon: string = cms_view_icon

    if (icon.toLowerCase().substring(0, 4) !== "http") {
        icon = QueryString.storage_account_url + "/cmsview/icons/48/" + icon
    }
    return icon
}




// WEBPACK FOOTER //
// ./src/ts/Findings.ts